import dayjs from 'dayjs';
import cn from 'classnames';

import Location from './Location';

import {
  getDay,
  isDatesInOneMonth,
  getWeekday,
  getMonthName,
} from 'utils/dates';
import { EventType } from 'graphql/types';

import css from './PosterDate.module.scss';

interface IProps {
  dateStart?: string;
  dateEnd?: string;
  place?: string;
  event: EventType | null;
}

export default function PosterDate(props: IProps) {
  const { dateStart, dateEnd, place, event } = props;

  const startDate = dateStart || event?.startDate;
  const finishDate = dateEnd || event?.finishDate;
  const eventPlace = place || event?.venue?.address?.city || '';

  const dayStart: string = getDay(startDate);
  const dayFinish: string = getDay(finishDate);

  const hasSingleMonth: boolean = !!isDatesInOneMonth(startDate, finishDate);
  const hasDifferentDaysInSameMonth: boolean = !!(
    dayStart &&
    dayFinish &&
    dayStart !== dayFinish
  );

  const weekday: string = hasDifferentDaysInSameMonth
    ? `${getWeekday(startDate, true)} - ${getWeekday(finishDate, true)}`
    : getWeekday(startDate);
  const monthName: string = getMonthName(startDate);

  if (!dayStart && !event) {
    return null;
  }

  return (
    <div className={css.wrapper}>
      <div
        className={cn(
          css.date,
          !hasDifferentDaysInSameMonth
            ? css.withOneDay
            : hasSingleMonth
            ? css.withSingleMonth
            : css.withDifferentMonth
        )}
      >
        {dayStart && (
          <>
            {hasDifferentDaysInSameMonth ? (
              <div className={css.days}>
                {hasSingleMonth
                  ? `${dayStart} - ${dayFinish}`
                  : `${dayjs(startDate).format('DD.MM')} - ${dayjs(
                      finishDate
                    ).format('DD.MM')}`}
              </div>
            ) : (
              <div className={css.days}>{dayStart}</div>
            )}
            <span className={css.weekday}>
              {hasSingleMonth && `${monthName}, `}
              {weekday}
            </span>
          </>
        )}
      </div>
      <Location place={eventPlace} isOffline={event?.isOffline ?? true} />
    </div>
  );
}
